import config from '@/config'
import { ServiceTypes } from '@/enums'
import { addAdobeDataLayerEventExitBeforeFinish } from '@/utils/adobe-analytics-data-layer'

function getSearchQueryParam (key: string, fallback = ''): string {
  const searchParams = new URLSearchParams(window.location.search)
  return searchParams.get(key) || fallback
}

function getSysEnv (): string {
  const mql = window.matchMedia('(max-width: 640px)')
  return mql.matches ? 'mobile' : 'browser'
}

function generateCartId (): string {
  const date = new Date()
  const randomNumber = Math.round((100 * Math.random()))

  return '' +
    date.getUTCFullYear() +
    (date.getUTCMonth() + 1).toString().padStart(2, '0') +
    date.getUTCDate() +
    (date.getUTCHours() + 1).toString().padStart(2, '0') +
    '-' +
    randomNumber.toString().padStart(3, '0')
}

// function injectScript () {
//   return new Promise((resolve, reject) => {
//     const s = document.createElement('script')
//     s.setAttribute('src', config.ANALYTICS_SCRIPT)
//     s.onload = resolve
//     s.onerror = reject
//     document.head.appendChild(s)
//   })
// }

export function analyticsSetup (): void {
//  injectScript()
  window.digitalData = {
    version: '2.0',
    page: {
      pageInfo: {
        pageName: '',
        sysEnv: getSysEnv(),
        category: {}
      }
    },
    clientID: getSearchQueryParam('clientid', 'member'),
    flow: '',
    cart: {
      cartID: generateCartId(),
      price: {
        basePrice: 0,
        cartTotal: 0,
        plusPrice: -1,
        nonPlusPrice: -1,
        savingsAmount: 0
      },
      item: []
    },
    group: {
      groupID: getSearchQueryParam('groupid'),
      classId: getSearchQueryParam('classid'),
      planId: getSearchQueryParam('classplanid')
    },
    event: [],
    trackPageView: function (pageName: string) {
      window.digitalData.page.pageInfo.pageName = pageName
      window.digitalData.event.push({ eventName: pageName, type: 'Page View' })
      window.digitalData._sendToAnalyticsServer('event-page-view')
    },
    trackEvent: function (eventName: string, parameters?: any) {
      window.digitalData.event.push({ eventName: eventName, type: 'Event', parameters })
      window.digitalData._sendToAnalyticsServer(eventName, parameters)
    },
    _sendToAnalyticsServer: function (event: any, parameters: any) {
      // const interval = setInterval(function () {
      //   if (typeof window._satellite === 'undefined') {

      //   } else {
      //     window._satellite.track(event, parameters)

      //     clearInterval(interval)
      //   }
      // }, 100)
    }
  }
}

// function trackEarlyExit (): void {
//   window.digitalData.trackEvent('event-exit-before-finish', { pageName: window.digitalData.page.pageInfo.pageName })
// }

export function addExitTracker (payload: any): void {
 addAdobeDataLayerEventExitBeforeFinish(payload)
}

export function removeExitTracker () : void {
  window.onbeforeunload = () => { /* noop */ }
}

export function trackFlow (flowName?: ServiceTypes): void {
  if (flowName) {
    window.digitalData.flow = ({
      [ServiceTypes.contacts]: 'contacts',
      [ServiceTypes.exam]: 'exam',
      [ServiceTypes.glasses]: 'glasses'
    } as Record<string, 'contacts' | 'exam' | 'glasses'>)[flowName]
  }
}

/**
 * @param totalRetailPrice - the sum of all charges
 * @param cartTotal - the price shown as estimated out of pocket cost
 * @param savings - if showEye360 = true, this is the savings for the plus pricing
 * @param plusPrice - if showEye360 = false, this should be -1
 * @param nonPlusPrice - if showEye360 = false, this should be -1
 */
export function trackSummaryPrice (totalRetailPrice: number, cartTotal: number, savings: number, plusPrice: number, nonPlusPrice: number): void {
  window.digitalData.cart.price = {
    basePrice: totalRetailPrice,
    cartTotal,
    plusPrice,
    nonPlusPrice,
    savingsAmount: savings
  }
}

export function trackUserSelection (items: string[]): void {
  window.digitalData.cart.item = items.map(item => ({ productName: item }))
}

export function trackPage (pageName: string, pageCategory?: string): void {
  window.digitalData.trackPageView(pageName)
  if (pageCategory) {
    window.digitalData.page.pageInfo.category = { primaryCategory: pageCategory }
  } else {
    window.digitalData.page.pageInfo.category = { primaryCategory: pageName }
  }
}

export function trackEvent (eventName: string): void {
  window.digitalData.trackEvent(eventName)
}
